import { useEffect } from 'react'

const PIXEL_ID = '1545009850674181'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

/**
 * Injects the Meta (Facebook) Pixel base code once and fires a PageView.
 * Safe to call from a top-level component; guards against double init.
 */
export function useMetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (window.fbq) {
      // Already initialized — just register the view.
      window.fbq('track', 'PageView')
      return
    }

    /* eslint-disable */
    ;(function (f: any, b: Document, e: string, v: string) {
      let n: any, t: HTMLScriptElement, s: Element | null
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s?.parentNode?.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
  }, [])
}

/** Fire a standard Meta Pixel event (e.g. 'InitiateCheckout', 'Purchase'). */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', event, params)
  }
}
